import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './AddressAutocomplete.module.css';

const AddressAutocomplete = ({ value, onChange, placeholder = "Saisissez une adresse..." }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [inputValue, setInputValue] = useState(value || '');
    const wrapperRef = useRef(null);

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchSuggestions = async (val) => {
        if (val.length < 3) {
            setSuggestions([]);
            return;
        }

        try {
            const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(val)}&limit=5`);
            const data = await response.json();
            setSuggestions(data.features || []);
        } catch (error) {
            console.error("Erreur API Adresse:", error);
        }
    };

    const handleInputChange = (e) => {
        const val = e.target.value;
        setInputValue(val);
        onChange(val); // Update parent state even as user types
        fetchSuggestions(val);
        setShowSuggestions(true);
    };

    const handleSelectSuggestion = (feature) => {
        const address = feature.properties.label;
        const [lon, lat] = feature.geometry.coordinates;
        setInputValue(address);
        onChange(address, { lat, lon });
        setShowSuggestions(false);
    };

    const clearInput = () => {
        setInputValue('');
        onChange('');
        setSuggestions([]);
        setShowSuggestions(false);
    };

    return (
        <div ref={wrapperRef} className={styles.wrapper}>
            <div className={styles.inputWrapper}>
                <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className={styles.iconMarker}
                />
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    onFocus={() => inputValue.length >= 3 && setShowSuggestions(true)}
                    placeholder={placeholder}
                    className={styles.input}
                />
                {inputValue && (
                    <button
                        type="button"
                        onClick={clearInput}
                        className={styles.clearButton}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                )}
            </div>

            {showSuggestions && suggestions.length > 0 && (
                <ul className={styles.suggestionsList}>
                    {suggestions.map((feature, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelectSuggestion(feature)}
                            className={styles.suggestionItem}
                        >
                            <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
                            <div>
                                <div className={styles.suggestionName}>{feature.properties.name}</div>
                                <div className={styles.suggestionCity}>{feature.properties.postcode} {feature.properties.city}</div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AddressAutocomplete;
